import React from "react"
import { DynamicIcon } from "lucide-react/dynamic"

import ContactManagementIcon from "@/components/ContactManagement"
import SalesPipelineIcon from "@/components/Sales"
import TasksAndCalendarIcon from "@/components/TasksAndCalendar"
import AutomationsIcon from "@/components/Automations"
import ProjectsIcon from "@/components/Projects"
import ReportingIcon from "@/components/Reporting"
import AiFeaturesIcon from "@/components/Ai-Features"

const EXPLORE_SLIDER_ICONS = {
  "contact-management": ContactManagementIcon,
  "sales-pipeline": SalesPipelineIcon,
  "tasks-and-calendar": TasksAndCalendarIcon,
  automations: AutomationsIcon,
  projects: ProjectsIcon,
  "sales-reports": ReportingIcon,
  "ai-tools": AiFeaturesIcon,
}

export const getExploreSliderIcon = icon => EXPLORE_SLIDER_ICONS[icon]

export const createLucideIcon = name => {
  const LucideIcon = props => <DynamicIcon name={name} {...props} />

  return LucideIcon
}
